import { Grid, Link } from "@mui/material"
import { crudGetList, ShowBase, useShowContext } from "ra-core"
import { FC, useEffect } from "react"
import { useDispatch } from "react-redux"
import { Content } from "~/components/content/Content"
import { EditObfsMappingContextProvider, useEditObfsMappingController } from "~/components/settings/encryption/EditObfsMappingContext"
import ObfsFieldsMappingList from "~/components/settings/encryption/ObfsFieldsMappingList"
import { ObfsTableSelectionCard } from "~/components/settings/encryption/ObfsTableSelectionCard"
import { RecPatch } from "~/dataProvider/tools"
import { ObfuscationMappingResponseDto } from "~/gen/api/encrypt"
import { OdResourcePageProps } from "~/types/resource"
import { decodeHashid, genUrlWithHashid } from "~/utils/hashid"
import { pages, sorts } from "~/utils/paramsWithGetMainList"
import { useResourceRegister } from "~/utils/resourceRegister"


const EditObfuscationMappings: FC<OdResourcePageProps & RecPatch> = (props) => {
  // useResourceRegister({ name: resource })
  useResourceRegister({ name: 'obfs-table' })
  useResourceRegister({ name: 'obfs-field' })

  const { id: hId, ...rest } = props
  const id = decodeHashid(hId || '')

  const ctrls = useEditObfsMappingController(id)

  return (
    <EditObfsMappingContextProvider value={ctrls}>
      <ShowBase resource={props.resource} id={id} basePath="">
        <EditObfuscationMappingsBody id={id} {...rest} />
      </ShowBase>
    </EditObfsMappingContextProvider>
  )
}


const EditObfuscationMappingsBody: FC<OdResourcePageProps & RecPatch> = ({
  id,
  options,
  resource,
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(crudGetList(resource || 'noop', pages(), sorts(), {}))
  }, [])
  
  const { record } = useShowContext<ObfuscationMappingResponseDto & RecPatch>()
  return (
    <Content 
      pageName="Edit Obfuscation Mappings" 
      resourceName="Edit Obfuscation Mappings" 
      breadcrumbs={[ ...(options?.breadcrumbs || []), { label: 'Obfuscation Mappings', path: `/${resource}` } ]}
      mainActions={
        record &&
        <Link href={genUrlWithHashid(`/encryption/mappings/$0/edit`, record.databaseId!, record.databaseName)} target="_blank" variant="caption"
          sx={{ mb: 1, mr: 1, display: 'inline-block' }}
        >
          Encryption Mappings...
        </Link>
      }
    >
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <ObfsTableSelectionCard />
        </Grid>
        <Grid item xs={12}>
          <ObfsFieldsMappingList />
        </Grid>
      </Grid>
    </Content>
  )
}


export default EditObfuscationMappings;
